export  const reportFileds = {
    one:{
            reportTitle:"检 测 报 告",
            reportNumber:"JCBG(01)250102568",
            sampleName:"系梁、横梁现场拼接焊缝",
            unit:"中铁四局集团有限公司",
            depart:"西渝高铁康渝段站前七标项目经理部",
            type:"委托检测",
            company:"中钢集团郑州金属制品研究院股份有限公司",
            testCenter:"国家金属制品质量检验检测中心"
    },
    two:{
        wUnit:"中铁四局集团有限公司西渝高铁康渝段站前七标项目经理部",
        jUnit:"天津新亚太工程建设监理有限公司",
        workName:"新建铁路西安至重庆高速铁路安康至重庆段XYKYZQ-7标",
        buildUnit:"京昆高速铁路西昆有限公司",
        cachesUnit:"中铁四局集团有限公司",
        workBody:"跨营达高速公路大桥钢箱系杆拱桥梁部（144M系梁，横梁）",
        pUnit:"海波重型工程科技股份有限公司",
        sampleName:"系梁、横梁现场拼接焊缝",
        sampleID:"JC(01)250104138",
        specificationModel:"钢板：（16、20、24、28、34）mm",
        brand:"Q345qZ35、Q345q",
        sampleNumber:"110",
        batchID:"---",
        representativeQuantity:"25",
        features:"未见明显外观缺陷",
        testCategory:"委托检测",
        entrustingDate:"2025-01-04",
        entrustingName:"钱军飞",
        witness:"雷豪",
        receivedDate:"---",
        completionDate:"2025-01-06",
        testingBasis:"GB/T11345-2023《焊缝无损检测 超声检测 技术、检测等级和评定》",
        judge:"Q/CR9211-2015《铁路钢桥制造规范》",
        testItem:"1.焊缝质量检测(超声波检测)",
        equipment:"超声波探伤仪(检 T106)",
        testConclusion:"委托样品所检项目符合Q/CR 9211-2015标准Ⅰ级要求。",
        dateIssue:"2025 年 01 月 09 日",
        remark:"现场检测，检测地点：四川省达州市石板镇拼装现；系梁，箱型横梁，工字横梁现场对接焊缝为全熔透焊缝，焊缝质量等级为Ⅰ级。"
    },
    three:{
        t1:"2.5Z9×9A60，2.5Z9×9A70",
        t2:"B",
        t3:"CSK-ⅠA、RB-2",
        t4:"Φ3×40mm-20dB",
        t5:"打磨光滑",
        t6:"I",
        t7:"锯齿形扫查，斜平行扫查",
        t8:"气保焊",
        t9:"深度 1:1",
        t10:"化学浆糊",
        t11:"焊接 24h 后",  
        t12:"+4dB",  
    }
}
export const reportPage1 = [
    {fieldName: "委托单位", fieldValue: "中铁四局集团有限公司西渝高铁康渝段站前七标项目经理部", lineHeight:10, textAlign:"center"},
    {fieldName: "监理单位 *", fieldValue: "天津新亚太工程建设监理有限公司",lineHeight:10, textAlign:"center"},
    {fieldName: "工程名称 *", fieldValue: "新建铁路西安至重庆高速铁路安康至重庆段XYKYZQ-7标",lineHeight:10, textAlign:"center" },
    {fieldName: "建设单位 *", fieldValue: "京昆高速铁路西昆有限公司",lineHeight:10, textAlign:"center" },
    {fieldName: "施工单位 *", fieldValue: "中铁四局集团有限公司",lineHeight:10, textAlign:"center" },
    {fieldName: "工程部位 *", fieldValue: "跨营达高速公路大桥钢箱系杆拱桥梁部（144M系梁，横梁）",lineHeight:10, textAlign:"center" },
    {fieldName: "生产单位 *", fieldValue: "海波重型工程科技股份有限公司",lineHeight:10, textAlign:"center" },
    {fieldName: "样品名称", fieldValue: "系梁、横梁现场拼接焊缝", fieldName2: "样品委托编号", fieldValue2: "JC(01)250104138",lineHeight:10},
    {fieldName: "规格型号", fieldValue: "钢板：（16、20、24、28、34）mm", fieldName2: "牌号 *", fieldValue2: "Q345qZ35、Q345q",lineHeight:10 },
    {fieldName: "样品数量", fieldValue: "110条", fieldName2: "批号/编号 *", fieldValue2: "---",lineHeight:10},
    {fieldName: "代表数量 *", fieldValue: "25件", fieldName2: "样品特征", fieldValue2: "未见明显外观缺陷",lineHeight:10},
    {fieldName: "检测类别", fieldValue: "委托检测", fieldName2: "委托日期", fieldValue2: "2025-01-04",lineHeight:10},
    {fieldName: "委托人", fieldValue: "钱军飞", fieldName2: "见证人", fieldValue2: "雷豪",lineHeight:10},
    {fieldName: "接收日期", fieldValue: "---", fieldName2: "检测完成日期", fieldValue2: "2025-01-06",lineHeight:10},
    {fieldName: "检测依据", fieldValue: "GB/T11345-2023《焊缝无损检测 超声检测 技术、检测等级和评定》",lineHeight:10, textAlign:"left"},
    {fieldName: "判定依据 *", fieldValue: "Q/CR9211-2015《铁路钢桥制造规范》",lineHeight:10, textAlign:"left" },
    {fieldName: "检测项目", fieldValue: "焊缝质量检测(超声波检测)",lineHeight:10, textAlign:"left" },
    {fieldName: "主要仪器设备", fieldValue: "超声波探伤仪(检 T106)",lineHeight:10, textAlign:"left" },
    // {fieldName: "检测结论", fieldValue: "委托样品所检项目符合Q/CR 9211-2015标准Ⅰ级要求", },
    // {fieldName: "签发日期", fieldValue: "2025 年 01 月 09 日", },
    // {fieldName: "备注", fieldValue: "1.现场检测，检测地点：四川省达州市石板镇拼装现场\n2.系梁，箱型横梁，工字横梁现场对接焊缝为全熔透焊缝，焊缝质量等级为 Ⅰ 级。", }
]




// WEBPACK FOOTER //
// ./src/utils/report.js